module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-28-min.976d3c8d.jpg";